import request from '../utils/axios'


// 获取地图管理列表
export function GetMapManagerShareLis(params) {
    return request({
      url: '/Map/GetMapManagerShareLis',
      method: 'post',
      data:params
    })
}


// 获取地图分享列表
export function GetMapShareLis(params) {
    return request({
      url: '/Map/GetMapShareLis',
      method: 'post',
      data:params
    })
}

// 添加地图管理
export function AddMapManage(params) {
    return request({
      url: '/Map/AddMapManage',
      method: 'post',
      data:params
    })
}

// 修改地图管理
export function UpdateMapManage(params) {
    return request({
      url: '/Map/UpdateMapManage',
      method: 'post',
      data:params
    })
}

// 删除地图管理
export function DeleteMapManage(params) {
    return request({
      url: `/Map/DeleteMapManage?id=${params.id}&docType=${params.docType}`,
      method: 'get',
    })
}

// 添加地图分享
export function AddMapShare(params) {
    return request({
      url: '/Map/AddMapShare',
      method: 'post',
      data:params
    })
}

// 修改地图分享权限
export function UpdateMapShare(params) {
    return request({
      url: '/Map/UpdateMapShare',
      method: 'post',
      data:params
    })
}

// 删除地图分享权限
export function DeleteMapShare(params) {
    return request({
      url: `/Map/DeleteMapShare?id=${params.id}&mapManageId=${params.mapManageId}`,
      method: 'get'
    })
}

// 获取资源账号树状图文件数据
export function GetTreeFile() {
    return request({
      url: '/Map/GetTreeFile',
      method: 'get'
    })
}

// 获取自己和他人共享地图列表
export function GetMyMapLis(params) {
  return request({
    url: '/Map/GetMyMapLis',
    method: 'post',
    data:params
  })
}

// 获取自己和他人共享地图列表(设计公司/普通用户)
export function GetMyMapLis2(params) {
  return request({
    url: '/Map/GetMyMapLis2',
    method: 'post',
    data:params
  })
}

// 是否存在临时数据(工作人员)
export function IsAnyMapTemporary(params){
  return request({
      url: '/Map/IsAnyMapTemporary',
      method: 'get',
      params: params
  })
}

// 推送图层数据到临时图层(工作人员
export function UploadMapData(params){
  return request({
      url: '/Map/UploadMapData',
      method: 'get',
      params: params
  })
}

// 推送单个数据(工作人员)
export function UploadAlonMapData(params) {
  return request({
    url: '/Map/UploadAlonMapData',
    method: 'post',
    data:params
  })
}

// 添加地图派图层公开
export function AddOpenMap(params) {
  return request({
    url: '/Map/AddOpenMap',
    method: 'post',
    data:params
  })
}

// 获取图层公开信息
export function GetOpenMapDetails(id) {
  return request({
    url: `/Map/GetOpenMapDetails?mapManageId=${id}`,
    method: 'get'
  })
}

// 设置公开图层
export function UpdataOpenMapPower(params) {
  return request({
    url: '/Map/UpdataOpenMapPower',
    method: 'post',
    data:params
  })
}

// 获取地图派团队分组列表(工作人员)
export function GetMapTeamGroup(params) {
  return request({
    url: '/Map/GetMapTeamGroup',
    method: 'post',
    data:params
  })
}

// 获取前端部门人员树状(组别管理)
export function GetDepartmentUser(type) {
  return request({
    url: `/Map/GetDepartmentUser?type=${type}`,
    method: 'get'
  })
}

// 获取图层管理列表
export function GetLayerManageLis(params) {
  return request({
    url: `/Map/GetLayerManageLis`,
    method: 'post',
    data:params
  })
}

// 添加图层管理
export function AddLayersManage(params) {
  return request({
    url: `/Map/AddLayersManage`,
    method: 'post',
    data:params
  })
}

// 获取图层详情
export function GetLayerManageDetails(id) {
  return request({
    url: `/Map/GetLayerManageDetails?id=${id}`,
    method: 'get'
  })
}

// 修改图层管理
export function UpdateLayerManage(params) {
  return request({
    url: `/Map/UpdateLayerManage`,
    method: 'post',
    data:params
  })
}

// 删除图层管理
export function DeleteLayerManage(id) {
  return request({
    url: `/Map/DeleteLayerManage?id=${id}`,
    method: 'get'
  })
}

// 关闭或开启图层
export function SetLayerState(id) {
  return request({
    url: `/Map/SetLayerState?id=${id}`,
    method: 'get'
  })
}

// 根据菜单UID获取显示图层信息
export function GetLayerInfoByUId(id) {
  return request({
    url: `/Map/GetLayerInfoByUId?id=${id}`,
    method: 'get'
  })
}

// 获取推送数据管理列表
export function GetUpdataData(params) {
  return request({
    url: `/Map/GetUpdataData`,
    method: 'post',
    data:params
  })
}

// 设置推送数据管理
export function SetUpdataData(params) {
  return request({
    url: `/Map/SetUpdataData`,
    method: 'post',
    data:params
  })
}